import { useQuery } from '@apollo/client/react';
import { NetworkStatus } from '@apollo/client';
import { GET_CONTROL_TAB_DATA } from '../graphql/controlQueries';
import { useControlSlices } from '../useControlSlices';
import { ControlResponse } from '../types';

export const useCommercialControl = (projectId: string | number) => {
  const { data, loading, error, refetch, networkStatus } = useQuery<{ baseProject: ControlResponse }>(
    GET_CONTROL_TAB_DATA,
    {
      variables: { id: projectId?.toString() },
      skip: !projectId,
      errorPolicy: 'all',
      fetchPolicy: 'cache-and-network',
    },
  );

  const slices = useControlSlices(projectId);

  return {
    data: data?.baseProject,
    loading,
    isDataReloading: networkStatus !== NetworkStatus.ready,
    error,
    refetch,
    ...slices,
  };
};
